// Delivery Challans — the Dispatch team's own document screen.
//
// The challan is where the physical work is recorded: vehicle and LR details,
// the dispatch credit/stock gate, proof of delivery, and the ONE action in the
// whole application that moves stock (moveChallanInventory in
// src/api-accounts/challan-lifecycle.js, posted at the dispatch action).
//
// Until this page existed the list lived only inside Accounts -> Sales, behind
// `access="accounts"` on the route AND a department gate on the API, so the
// Dispatch team could raise a challan from the queue and then never see it
// again. Both gates now admit Dispatch for delivery challans specifically
// (requireChallanOrAccountsUser in src/api-accounts/commercial-documents.js).
//
// The list itself is the SAME component Accounts use, deliberately: the
// lifecycle buttons (Dispatch, POD, Deliver, Return, Cancel, Re-open, Print)
// are already built and already correct there, and a second copy would drift.
// Only the page framing around it is Dispatch's own.
//
// Billing is NOT one of those buttons: the tax invoice comes from the
// quotation or the proforma, never from the challan.

import { DispatchAndChallansPage } from './DispatchAndChallansPage';

export function DispatchChallansPage() {
  return <DispatchAndChallansPage />;
}

export default DispatchChallansPage;

